import { render, staticRenderFns } from "./page-invoice.vue?vue&type=template&id=01b6fc0a&"
import script from "./page-invoice.vue?vue&type=script&lang=js&"
export * from "./page-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports